import {API} from "aws-amplify";
import {awsApiName} from "../../shared/amplify/amplify-utils";
import {AuditLogsResponse} from "../../entity/resource/audit-logs-response";

export class AuditLogsAgent {
    getAuditLogs = async (organizationId: string, batchId: string): Promise<AuditLogsResponse[]> => {
        return await API.get(awsApiName, `/organizations/${organizationId}/async-job-status/batch/${batchId}`, {});
    }
}
